import React from 'react'

const NoticeBoard = () => {
  return (
    <div>
      
    </div>
  )
}

export default NoticeBoard
